import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AddLeadsForm } from "@/features/lead-gen/components/AddLeadsForm";
import { LeadGenDetailShell } from "@/features/lead-gen/components/LeadGenDetailShell";
import { useLeadGen } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads/new")({
    component: AddLeadsPage,
    validateSearch: (search: Record<string, unknown>) => ({
        company: typeof search.company === "string" ? search.company : undefined,
    }),
});

function AddLeadsPage() {
    const { company: defaultCompany } = Route.useSearch();
    const { setLeads, artifacts, companies, templates, addCompany, setCompanyTeams, enqueueLeadEmailEnrichment } =
        useLeadGen();
    const navigate = useNavigate();

    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
        { label: "Add lead", route: { to: "/sales/leads/new" } },
    ]);

    return (
        <LeadGenDetailShell backTo="/sales/leads" backLabel="All leads">
            <AddLeadsForm
                artifacts={artifacts}
                companies={companies}
                templates={templates}
                defaultCompany={defaultCompany}
                onCancel={() => void navigate({ to: "/sales/leads" })}
                onAddCompany={(name) => {
                    addCompany(name);
                }}
                onAddCompanyTeam={(companyName, team) => {
                    const company = companies.find(
                        (item) => item.name.localeCompare(companyName, undefined, { sensitivity: "base" }) === 0
                    );
                    if (!company) {
                        addCompany(companyName, [team]);
                        return;
                    }
                    if (
                        company.teams.some((item) => item.localeCompare(team, undefined, { sensitivity: "base" }) === 0)
                    ) {
                        return;
                    }
                    setCompanyTeams(company.company_id, [...company.teams, team]);
                }}
                onAdd={(lead) => {
                    setLeads((current) => [...current, lead]);
                    enqueueLeadEmailEnrichment(lead);
                    void navigate({
                        to: "/sales/leads/$leadId",
                        params: { leadId: lead.lead_id },
                        search: { generate: true },
                    });
                }}
            />
        </LeadGenDetailShell>
    );
}
